import { useSyncExternalStore } from 'react';

export type ToastTone = 'ok' | 'error';

export interface ToastItem {
  id: number;
  tone: ToastTone;
  text: string;
}

let items: ToastItem[] = [];
let seq = 0;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((fn) => fn());
}

export function dismissToast(id: number) {
  const next = items.filter((t) => t.id !== id);
  if (next.length === items.length) return;
  items = next;
  emit();
}

/** Show a short message at the bottom of the screen. Errors stay a little longer. */
export function pushToast(tone: ToastTone, text: string) {
  const id = ++seq;
  items = [...items.slice(-2), { id, tone, text }];
  emit();
  window.setTimeout(() => dismissToast(id), tone === 'error' ? 6500 : 4000);
}

export function useToasts(): ToastItem[] {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => items,
  );
}
